import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { http } from "../../../../../services/HttpService";

export const useSaveRepeatMdIntegration = (options = {}) => {
  return useMutation(
    (dto) =>
      http.put(
        HTTP_ENDPOINTS.repeatMdIntegration.saveRepeatMdIntegration(),
        dto,
      ),
    options,
  );
};
